
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_15oj2_1q93l_5"
};
  